// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";

import { Container } from "react-components";

import Seo from "../../components/seo";
import Layout from "../../components/layout";
import BlogList from "../../components/blogList";
import BlogMenu from "../../components/blogMenu";

import styles from "./articlesList.css";

export default function ArticlesList({ data, pageContext }) {
    return (
        <Layout
            background={data.contentfulArticlesList.backgroundColor}
            footerBackground={data.contentfulArticlesList.backgroundColor}
            navigation={"blog"}
        >
            <Seo
                title={data.contentfulArticlesList.metaTitle}
                description={data.contentfulArticlesList.metaDescription}
            />
            <Container size={"full"} className={styles.container}>
                <BlogMenu currentId={pageContext.id} />
                <BlogList
                    topItems={data.contentfulArticlesList.blocks}
                    items={data.allContentfulArticle.nodes}
                    showSubscribe
                />
            </Container>
        </Layout>
    );
}

ArticlesList.propTypes = {
    data: PropTypes.object,
    pageContext: PropTypes.shape({
        id: PropTypes.string,
        categoryId: PropTypes.string,
    }),
};

export const query = graphql`
    query Blog($id: String!, $categoryIdRegex: String = "//") {
        contentfulArticlesList(id: { eq: $id }) {
            slug
            title
            metaTitle
            metaDescription
            backgroundColor
            blocks {
                id
                slug
                publishDate
                body {
                    raw
                }
                type
                categories {
                    id
                    slug
                    title
                }
                preview {
                    gatsbyImageData(layout: FULL_WIDTH, width: 600)
                }
                title
                excerpt {
                    raw
                }
            }
        }

        allContentfulArticle(
            filter: { categories: { elemMatch: { id: { regex: $categoryIdRegex } } } }
            sort: { fields: publishDate, order: DESC }
        ) {
            nodes {
                id
                slug
                publishDate
                body {
                    raw
                }
                type
                categories {
                    id
                    slug
                    title
                }
                preview {
                    gatsbyImageData(layout: FULL_WIDTH, width: 600)
                }
                title
                excerpt {
                    raw
                }
            }
        }
    }
`;
